import type { ReactNode } from 'react'
import css from './Text.module.css'

interface TextNormBoldProps {
    children: ReactNode
    className?: string
}

const TextNormBold = ({ children, className }: TextNormBoldProps) => {
    return <div className={[css.normBold, className].filter(Boolean).join(' ')}>{children}</div>
}

export default TextNormBold
